import { makeStyles } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { rem, vh, vw } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

const dialogPaper: CSSProperties = {
  borderRadius: 'unset',
  height: '80.07vh',
  background: themeColor.modalBackground,
  '@media (min-width: 1280px)': {
    maxWidth: vw(54.125),
  },
  '@media (min-width: 1024px) and (min-height: 768px)': {
    maxHeight: vh(71),
  },
  '@media (min-width: 1600px) and (min-height: 900px)': {
    maxHeight: vh(71),
  },
  '@media (min-width: 1600px) and (min-height: 1200px)': {
    maxHeight: vh(60),
  },
};

export const styles = makeStyles(() => ({
  dialogPaper: dialogPaper,
  dialogPaperText: {
    ...dialogPaper,
    height: vh(89.99),
    marginTop: vh(10.01),
    maxHeight: 'unset',
    margin: 0,
  },
  dialogPaperFullWidth: {
    minWidth: '100%',
  },
  mainContainer: {
    flexGrow: 1,
    border: `1px solid ${themeColor.secondaryLight}`,
  },
  title: {
    display: 'flex',
    padding: '2.08vh 1.464vw',
    backgroundColor: 'white',
    borderBottom: `1px solid ${themeColor.secondaryLight}`,
    alignItems: 'center',
    justifyContent: 'space-between',

    '& svg': {
      height: '3.125vh',
      width: '3.125vh',
    },
  },
  titleContent: {
    fontSize: rem(1.285),
    lineHeight: rem(1.428),
    fontWeight: 500,
    color: themeColor.modalTitle,
  },
  mainContent: {
    flexGrow: 1,
    padding: '0 1.464vw 2.604vh 1.464vw',
  },
}));
